import React from 'react';
import { FadeIn } from './ui';
import { IMAGES } from './constants';
const ITEMS = ['Son las 11 de la noche y no podés dejar de darle vueltas a lo mismo.', 'Tenés algo que te pesa pero no querés cargar a los que querés.', 'Cuando hablás con alguien cercano sentís que lo estás condicionando sin querer.', 'Para hablar con un psicólogo tenés que esperar semanas. Ahora lo necesitás.', 'No sabés bien qué decir ni por dónde arrancar. Solo sabés que algo no está bien.', 'Querés un espacio solo tuyo. Sin historia previa. Sin que te juzguen.'];
export function Problem() {
  return <section className="w-full bg-[#213354] px-6 py-20 sm:py-28" data-id="element-77">
      <div className="mx-auto grid max-w-6xl items-start gap-12 lg:grid-cols-2" data-id="element-78">
        <FadeIn className="lg:sticky lg:top-20" data-id="element-79">
          <div className="overflow-hidden rounded-3xl border border-[#8BA3C7]/20" data-id="element-80">
            <img src={IMAGES.problem} alt="Persona desvelada rodeada de pensamientos enredados" className="h-full w-full object-cover" data-id="element-81" />
          </div>
        </FadeIn>

        <div data-id="element-82">
          <FadeIn data-id="element-83">
            <h2 className="font-serif text-3xl text-white sm:text-4xl" data-id="element-84">
              ¿Te suena alguna de estas?
            </h2>
          </FadeIn>
          <div className="mt-8 space-y-4" data-id="element-85">
            {ITEMS.map((item, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-86">
                <div className="rounded-r-xl border-l-2 border-[#8BA3C7] bg-[#1B2B4A]/40 py-4 pl-5 pr-4" data-id="element-87">
                  <p className="text-white/90 leading-relaxed" data-id="element-88">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>

      <FadeIn className="mx-auto mt-16 max-w-3xl text-center" data-id="element-89">
        <p className="font-serif text-2xl italic text-[#8BA3C7] sm:text-3xl" data-id="element-90">
          Si te identificaste con algo de esto, EscuchaYA es para vos.
        </p>
      </FadeIn>
    </section>;
}